module.exports = __webpack_public_path__ + "static/media/icon-document-download.4cbd3f05.svg";